import styled from 'styled-components';

import { device } from 'common/constants/mediaQueries';

export const Container = styled.div``;

export const Div = styled.div``;

/* The title is the topbar's; this row holds the screen's actions. */
export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s3);
  margin-bottom: var(--s5);
`;

/* ── the event form ───────────────────────────────────────────────────── */

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s5);
`;

/** Vertical rhythm between the rows inside one section. */
export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/** The design's `.grid-2`. */
export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--s4);
  align-items: start;

  @media ${device.laptop} {
    grid-template-columns: 1fr;
  }
`;

/** The design's `.grid-3`, collapsing to two then one. */
export const Grid3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--s4);
  align-items: start;

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
  }
`;

/* Both switches sit in the section head, so they stay on one line with it. */
export const Switches = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s5);
`;

/*
 * The dropzone is a 1.7:1 cover, so a full-width dashed box across 936px
 * would promise a shape the image will not be. Half the row is closer.
 */
export const Dropzone = styled.div`
  max-width: 480px;
`;

/** The design's `.actionbar`, standing on its own under the stack of cards. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  padding: var(--s4) var(--s5);
  background: var(--surface-alt);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
`;

export const Spacer = styled.div`
  flex: 1;
`;
